import { Relation } from "@nozbe/watermelondb";
import { field, immutableRelation } from "@nozbe/watermelondb/decorators";
import { Associations } from "@nozbe/watermelondb/Model";
import ProductKit from "./ProductKit";
import Product from "./Product";
import { BaseModel } from "./Base";

export default class ProductKitItem extends BaseModel {
  static table = "product_kit_items";

  static associations: Associations = {
    productKit: { type: "belongs_to", key: "product_kit_id" },
  };

  @immutableRelation("product_kits", "product_kit_id")
  productKit: Relation<ProductKit>;

  @immutableRelation("products", "product_id")
  product: Relation<Product>;

  @field("quantity") quantity: number;
  @field("price") price: number;
}
